module.exports = __webpack_public_path__ + "static/3-65b5ffa884304844fcaf49f74fb33baf.jpg";